module.exports = __webpack_public_path__ + "img/17_64.5b21eb75.png";